export default __webpack_public_path__ + "7dbbbb674aa4bbe1e014942f532b99bf.svg";